import React from 'react';

export class WaterSanitationIcon extends React.PureComponent {
  render() {
    return (
      <svg width="71" height="60" viewBox="0 0 71 60" {...this.props}>
        <g fillRule="nonzero" fill="none">
          <path
            d="M36.167 12.87a1.16 1.16 0 0 0-.932-.492 1.16 1.16 0 0 0-.931.49l-10.805 15.02a1.2 1.2 0 0 0-.06.096c-2.196 3.767-2.169 8.346.072 12.247a13.478 13.478 0 0 0 23.458-.015c2.23-3.891 2.252-8.448.06-12.192-.019-.03-.038-.066-.058-.095L36.167 12.87zm8.812 26.206a11.184 11.184 0 0 1-19.479.013c-1.844-3.21-1.882-6.816-.106-9.9l9.839-13.67 9.841 13.712c1.773 3.059 1.739 6.644-.095 9.845z"
            fill="currentColor"
          />
          <path
            d="M45.025 39.207a11.184 11.184 0 0 1-19.478.013c-1.845-3.21-1.883-6.816-.107-9.9l9.839-13.67 9.841 13.712c1.773 3.06 1.74 6.645-.095 9.845z"
            fill="#FFF"
          />
          <path
            d="M41.709 32.627c-.634 0-1.148.513-1.148 1.147a5.398 5.398 0 0 1-5.409 5.374 1.147 1.147 0 0 0 0 2.295 7.696 7.696 0 0 0 7.704-7.669 1.147 1.147 0 0 0-1.147-1.147z"
            fill="currentColor"
          />
          <path
            d="M62.645 21.273a1.147 1.147 0 0 0-1.918 0l-7.638 11.645c-.231.364-.25.823-.05 1.205.198.378.584.619 1.01.63h6.172a26.423 26.423 0 0 1-8.985 16.16c-4.66 3.997-10.511 6.274-16.052 6.274-3.611 0-7.39-.982-10.926-2.826a27.205 27.205 0 0 1-9.322-8 1.147 1.147 0 1 0-1.852 1.354 29.504 29.504 0 0 0 10.112 8.674c3.863 2.014 8.009 3.079 11.988 3.079 6.08 0 12.476-2.464 17.546-6.811a28.994 28.994 0 0 0 9.811-17.903h6.782a1.184 1.184 0 0 0 .96-1.822l-7.638-11.66zm-6.471 11.186l5.512-8.405 5.512 8.405H56.174zM17.43 25.346a1.176 1.176 0 0 0-1.01-.632h-6.172a26.423 26.423 0 0 1 8.985-16.16c4.66-3.996 10.51-6.273 16.051-6.273 3.612 0 7.39.982 10.927 2.825a27.205 27.205 0 0 1 9.322 8 1.147 1.147 0 1 0 1.851-1.354 29.504 29.504 0 0 0-10.112-8.674C43.409 1.065 39.264 0 35.284 0 29.204 0 22.81 2.464 17.74 6.81a28.994 28.994 0 0 0-9.812 17.904H1.146a1.184 1.184 0 0 0-.96 1.821l7.637 11.652a1.146 1.146 0 0 0 1.92.006l7.637-11.659c.23-.358.25-.812.05-1.188zM8.783 35.414L3.27 27.009h11.024l-5.512 8.405z"
            fill="#2C3038"
          />
        </g>
      </svg>
    );
  }
}
